module.exports = __webpack_public_path__ + "static/media/DualLunchMenu.b01e6c21.pdf";